import { Auth0Region } from '@ocula/auth';
import { Card, LinkButton, Text } from '@ocula/ui';
import { CheckIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import * as Select from '@radix-ui/react-select';
import { useEffect, useState } from 'react';

import { auth0LikeButton } from './auth0LikeButton.css';
import styles from './landingPage.css';
import select from './selectRegionComponent.css';

type Props = {
  goToContinueSession?: () => void;
};

const SelectRegionComponent = ({ goToContinueSession }: Props) => {
  const storedRegion = localStorage.getItem('auth0Region');
  const [auth0Region, setAuth0Region] = useState(storedRegion ?? undefined);
  const previousSessionExists = localStorage.getItem('auth0Name');
  const handleUndefinedRegion = () => {
    if (auth0Region === undefined) {
      // TODO replace with disabled button
      // eslint-disable-next-line no-alert
      alert('Please select your region');
    }
  };
  useEffect(() => {
    localStorage.removeItem('orgIdStatus');
  }, []);
  return (
    <div className={styles.componentContainer}>
      <div className={styles.cardHeader}>
        <Card.Title>Please select your region</Card.Title>
        <Text variant="meta">
          Choosing the correct region for your organisation is important as your login credentials may not work if the
          wrong region is selected.
        </Text>
      </div>

      <div className={styles.cardContent}>
        <Select.Root required defaultValue={auth0Region} onValueChange={(value: Auth0Region) => setAuth0Region(value)}>
          <Select.Trigger className={select.selectTrigger} aria-label="Region Select">
            <Select.Value placeholder="Select your region" />
            <Select.Icon className={select.selectIcon}>
              <ChevronDownIcon />
            </Select.Icon>
          </Select.Trigger>
          <Select.Portal>
            <Select.Content className={select.selectContent}>
              <Select.Viewport className={select.selectViewport}>
                <Select.Group>
                  <Select.Item className={select.selectItem} value={Auth0Region.EU}>
                    <Select.ItemText>
                      <Text>UK/Europe</Text>
                    </Select.ItemText>
                    <Select.ItemIndicator className={select.selectItemIndicator}>
                      <CheckIcon />
                    </Select.ItemIndicator>
                  </Select.Item>
                  <Select.Item className={select.selectItem} value={Auth0Region.US}>
                    <Select.ItemText>
                      <Text>North America</Text>
                    </Select.ItemText>
                    <Select.ItemIndicator className={select.selectItemIndicator}>
                      <CheckIcon />
                    </Select.ItemIndicator>
                  </Select.Item>
                </Select.Group>
              </Select.Viewport>
            </Select.Content>
          </Select.Portal>
        </Select.Root>
        <LinkButton
          to={auth0Region ? `/${auth0Region}` : '/'}
          variant="primary"
          className={auth0LikeButton}
          onClick={() => {
            handleUndefinedRegion();
            localStorage.setItem('orgIdStatus', 'notConfirmedByUser');
          }}
        >
          Continue
        </LinkButton>
        {previousSessionExists && (
          <LinkButton variant="secondary" className={auth0LikeButton} onClick={goToContinueSession}>
            Go back
          </LinkButton>
        )}
      </div>
    </div>
  );
};

export default SelectRegionComponent;
